import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

const BoatLeadForm = ({ formData, errors, handleChange }) => {
  return (
    <form className="boat-lead-form">

      <div className="form-group-row">
        <div className="form-group">
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name*"
            className={errors.fullName ? 'error' : ''}
          />
          {errors.fullName && <span className="error-message">{errors.fullName}</span>}
        </div>

        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email*"
            className={errors.email ? 'error' : ''}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>
      </div>

      <div className="form-group-row">

        <div className="form-group">
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone*"
            className={errors.phone ? 'error' : ''}
          />
          {errors.phone && <span className="error-message">{errors.phone}</span>}
        </div>

        <div className="form-group datepicker-group">
          <DatePicker
            selected={formData.date ? new Date(formData.date) : null}
            onChange={date => handleChange({ target: { name: 'date', value: date ? date.toISOString().split('T')[0] : '' } })}
            dateFormat="MM/dd/yyyy"
            placeholderText="mm/dd/yyyy"
            minDate={new Date()}
            className={errors.date ? 'error' : ''}
            customInput={
              <div style={{ position: 'relative', width: '100%' }}>
                <input
                  type="text"
                  value={formData.date}
                  readOnly
                  className={`custom-datepicker-input${errors.date ? ' error' : ''}`}
                  style={{ width: '100%', paddingRight: 32 }}
                  placeholder="mm/dd/yyyy"
                />
                <span className="calendar-icon">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                </span>
              </div>
            }
          />
          {errors.date && <span className="error-message">{errors.date}</span>}
        </div>
      </div>

      <div className="form-group">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="What would you like to know? (e.g. availability, special requests, itinerary...)"
          className={errors.message ? 'error' : ''}
        />
        {errors.message && <span className="error-message">{errors.message}</span>}
      </div>
    </form>
  );
};

export default BoatLeadForm;

